import { AnnotationRenderer } from '../AnnotationRenderer';
const RGB = 255;
export class AnnotationRendererV1 extends AnnotationRenderer {
    render() {
        const context = this.context;
        const annotations = this.annotations;
        // Set viewport width and height according to document dimensions
        // square get's handled like portrait - see above
        if (this.width > this.height) {
            this.canvas.width = 1024;
            this.canvas.height = 768;
        }
        else {
            this.canvas.width = 768;
            this.canvas.height = 1024;
        }
        this.clear();
        context.lineCap = 'round';
        annotations.forEach((annotation) => {
            renderAnnotation(annotation);
        });
        function renderAnnotation(annotation) {
            const points = annotation.points;
            const pointCount = points.length;
            if (pointCount > 0) {
                let point = points[0];
                context.beginPath();
                context.moveTo(point.x, point.y);
                for (let i = 1; i < pointCount; i++) {
                    point = points[i];
                    context.lineTo(point.x, point.y);
                }
                const color = [
                    annotation.strokeColor.r * RGB,
                    annotation.strokeColor.g * RGB,
                    annotation.strokeColor.b * RGB,
                    annotation.strokeColor.a,
                ].join(',');
                context.lineWidth = annotation.lineWidth;
                context.strokeStyle = `rgba(${color})`;
                context.stroke();
            }
        }
    }
}
//# sourceMappingURL=AnnotationRendererV1.js.map